<template>
  <div class="copy">
    <button class="copy-button" @click="copy"></button>
  </div>
</template>

<script>
export default {
  name: "CopyButton",
  components: {},
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
    };
  },
  methods: {
    copy(event) {
      event.stopPropagation();
      var textarea = document.createElement('textarea');
      textarea.value = this.text;

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 9999);  // 추가

      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  }
};
</script>

<style lang="scss" scoped>
.copy {
  visibility: visible;
  .copy-button {
    cursor: pointer;
    outline: none;
    border: none;
    width: 20px;
    height: 20px;
    background: url(@/assets/img/icon-copy-default.svg) no-repeat center;
    background-size: 20px;
  
    &:hover {
      background: url(@/assets/img/icon-copy-hover.svg);
      background-size: 20px;
    }
  }
}
</style>
